import React, { useRef } from 'react';
import { NavLink } from "react-router-dom";
import { motion } from 'framer-motion';
import '../pages/css/CustomSoftwareDevelopment.css';
import '../pages/css/Home.css';
import banner from '../images/services-banner.jpg';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import OurPartner from '../pages/components/OurPartner';
import Industries from '../pages/components/Industries';
import TechStack from '../pages/components/TechStack';
import CaseStudy from '../pages/components/CaseStudy';
import ComparisonTable from '../pages/components/ComparisonTable';
import WorkSteps from '../pages/components/WorkSteps';
import ClientReviews from '../pages/components/ClientReviews';
import WorldwideCountries from '../pages/components/WorldwideCountries';
import Faq from '../pages/components/Faq';
import servicebg from '../images/testimonial-bg.png';
import { FaLaptopCode, FaBrain, FaMobileAlt, FaBuilding, FaBoxOpen, FaMobile, FaRocket, FaTools, FaUsers, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';

const Services = () => {
    const services = [
    {
        Icon: FaLaptopCode,
        title: "Custom Software Development",
        desc: "We craft bespoke software solutions tailored to your business needs, combining intuitive design, robust architecture, and Azure cloud integration. From backend systems to full-scale platforms, we ensure scalability, data security, seamless API connectivity, and performance optimization to help you build, automate, and grow with confidence.",
        link: "/custom-software-development"
    },
    {
        Icon: FaBrain,
        title: "Artificial Intelligence",
        desc: "We offer advanced solutions that harness the power of machine learning, artificial intelligence (AI), and data analytics to optimize business processes, predict trends, and unlock actionable insights. By leveraging cutting-edge technologies",
        link: "/artificial-intelligence"
    },
    {
        Icon: GiRobotAntennas,
        title: "AI Agent Development",
        desc: "Building intelligent, adaptive AI agents designed to solve complex problems and enhance user experiences. From conversational bots to advanced machine learning models, we create cutting-edge solutions that empower businesses and optimize workflows across industries",
        link: "/ai-agent-development"
    },
    {
        Icon: MdOutlineRocketLaunch,
        title: "MVP Development",
        desc: "Turning visionary ideas into actionable prototypes with lean, scalable MVPs for faster market validation and growth.We transform bold ideas into reality with laser-focused MVPs—crafted to test core assumptions, gather user feedback, and gain traction fast. Because in startups, speed and focus win.",
        link: "/minimum-viable-product"
    },
    {
        Icon: FaMobileAlt,
        title: "Website & Mobile App Development",
        desc: "Crafting seamless, high-performance digital products tailored to your business goals. From responsive websites to scalable mobile apps, we turn ideas into intuitive, user-driven experienced across platforms.",
        link: "/website-and-app-development"
    },
    {
        Icon: FaBuilding,
        title: "Enterprise Web Development",
        desc: "Delivering robust, scalable, and secure web solutions designed to drive your enterprise forward. From complex web applications to custom enterprise portals, we build digital infrastructures that enhance performance and accelerate growthacross your organization.",
        link: "/enterprise-web-development"
    },
    {
        Icon: FaBoxOpen,
        title: "Product Development",
        desc: "We specialize in delivering end-to-end product development solutions. From conceptualization and design to development and deployment, we craft tailored digital products that align with your business objectives. Whether you're building an engaging website or a high-performance",
        link: "/product-development"
    },
    {
        Icon: FaMobile,
        title: "Blockchain",
        desc: "We design and develop secure, decentralized blockchain applications tailored to your business goals. From smart contract engineering to scalable dApps and Web3 integrations, our solutions empower transparency, automation, and trust.",
        link: "/blockchain-development"
    },
];

    
    return (
        <>
            <section
                id="home"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative', // Important for overlay
                    zIndex: 1,
                }}
            >
                {/* Overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)', // semi-transparent black
                        zIndex: 2,
                    }}
                ></div>

                <section className="container-fluid px-3 px-md-5 pt-2 pb-4 pb-md-5" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row g-0">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center align-items-md-start text-center text-md-start p-3 p-md-4">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.8, ease: 'easeOut' }}
                                className="w-100"
                            >
                                <h1 className="display-5 display-md-4 fw-bold title-text text-white"> Our <span className="highlight-orange">Service</span> Offerings
                                </h1>
                                <p className="mb-4 fw-semibold fs-3 text-white" style={{ maxWidth: '800px' }}>
                                    <span className="highlight-orange">Empowering  </span> your business through innovative digital solutions — from AI to web development, tailored for your growth.
                                </p>
                                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-md-start align-items-center">
                                    <button className="btn custom-orange-btn py-3 px-5 fw-bold d-flex align-items-center text-center" onClick={() => window.location.href = '/case-studies'}>
                                        Case Study <FaArrowRight className="ms-2" />
                                    </button>
                                    <button className="btn custom-orange-btn py-3 px-5 fw-bold d-flex align-items-center text-center" onClick={() => window.location.href = '/contact-us'}>
                                        Contact Us <FaArrowRight className="ms-2" />
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </section>
            <section id="services" className="services-section" style={{ backgroundImage: `url(${servicebg})` }}>
                <motion.section className="container my-5"
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: false, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}>
                    <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                        <div className="px-3 fw-bold responsive-heading"><span className="highlight-orange">Services</span>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                            We ideate, strategize, design, and develop <span className="highlight-orange">digital solutions </span> that accelerate <span className="highlight-orange"> digital transformation </span>across various industries.
                        </span>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Get in Touch With Us
                        </a>
                    </div> */}
                </motion.section>
                <div className="container my-5">
                    <div className="row">
                        {services.map(({ Icon, title, desc, link }, idx) => (
                            <motion.div
                                key={idx}
                                className="col-12 col-sm-6 col-md-3 mb-4"
                                initial={{ x: idx < 4 ? -50 : 50, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: false, amount: 0.5 }}
                                transition={{ duration: 0.8, ease: 'easeOut', delay: idx * 0.2 }}
                                style={{ cursor: 'pointer' }}
                                onClick={() => window.open(link, '_blank')}
                            >
                                <div className="services-card">
                                    <Icon size={48} className="services-icon" />
                                    <h5 className="fw-bold mb-2">{title}</h5>
                                    <p className="mb-0" style={{ fontSize: '14px' }}>
                                        {desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

            </section>
            
            <OurPartner />

            <Industries />
            <TechStack />
            <CaseStudy />
            {/* <ComparisonTable /> */}
            <WorkSteps />
            <ClientReviews />
            <WorldwideCountries />
            <Faq />

        </>
    );
};

export default Services;
